import { render, staticRenderFns } from "./SurveyQuestionares.vue?vue&type=template&id=ed3bbbee&"
import script from "./SurveyQuestionares.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports